// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__2egHj","footer":"ModalFilter_footer__2Nadz"};